import { Breadcrumbs, NextIcon } from '@kvdbil/components';
import React, { ReactNode } from 'react';
import { useTranslation } from '~/Locale';
import Link from '~/App/shared/components/Link';

interface Props {
  links: { component: ReactNode }[];
}

const BlogBreadcrumbs = ({ links }: Props) => {
  const { t } = useTranslation();

  return (
    <Breadcrumbs
      links={[
        { component: <Link to={'/ROUTES.BLOG'}>{t('Blog')}</Link> },
        ...links
      ]}
      separator={<NextIcon />}
      onlyLastTruncated
    />
  );
};

export default BlogBreadcrumbs;
